export default function BlogFooter() {
  return (
    <footer className="bg-black border-t border-white/10 px-6 pt-16 pb-8">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <a href="/" aria-label="Paisums home">
            <img src="/logo-white.svg" alt="Paisums Technology" className="h-6 w-auto" />
          </a>
          <span className="text-white/40 text-sm">· Insights</span>
        </div>
        <div className="flex gap-5 text-white/60 text-sm">
          <a href="/" className="hover:text-white">Home</a>
          <a href="/#services" className="hover:text-white">Services</a>
          <a href="/#defence" className="hover:text-white">Defence-Ready</a>
          <a href="/#contact" className="hover:text-white">Contact</a>
        </div>
        <div className="text-white/40 text-xs">© {new Date().getFullYear()} Paisums Technology</div>
      </div>
    </footer>
  );
}
